import React from 'react';

const OptimiseCapital = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="commitement-content">
          <p>
            Our focus is on generating strong business cash flows and maintaining strict capital
            discipline in investing in profitable high IRR projects. Our aim is to maintain a strong
            balance sheet through proactive liability management. We also review all investments
            (organic and acquisitions) based on our strict capital allocation framework, with a view
            to maximising returns for shareholders.
          </p>
        </div>

        <div className="commitement-content commitment-kits">
          <h5>KPIs</h5>
          <ul className="green-bullets">
            <li>FCF post-capex</li>
            <li>Net Debt/EBITDA (Consol)</li>
            <li>EPS (before exceptional items)</li>
            <li>Interest cover ratio</li>
            <li>Dividend</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>Risks</h5>
          <ul className="green-bullets">
            <li>Access to capital</li>
            <li>Fluctuation in commodity prices (including oil) and currency exchange rates</li>
          </ul>
          <ul className="green-bullets">
            <li>Regulatory and legal risk</li>
            <li>Tax related matters</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>FY2020 Update</h5>
          <ul className="green-bullets">
            <li>
              FCF reduced from 11,553 INR crore to 7,130 INR crore, down 38% y-o-y
            </li>
            <li>
              Net debt decreased from ₹26,956 crore to ₹21,273 crore
            </li>
          </ul>
          <ul className="green-bullets">
            <li>
              Net Debt/EBITDA at 1.0x on a consolidated basis.
            </li>
            <li>
              Dividend worth c.₹1,450 crore, ₹3.90/share distributed in VEDL
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default OptimiseCapital;